import { createContext } from "react";
import { PaymentContextData } from "./types";

export const PaymentContext = createContext({} as PaymentContextData);
